// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".showBorder{border:1px dashed #a9a9a9;border-radius:5px}", "",{"version":3,"sources":["webpack://./src/plugins/ShowBlocks/showBlocks.css"],"names":[],"mappings":"AAAA,YACE,yBAA2B,CAC3B,iBACF","sourcesContent":[".showBorder {\r\n  border: 1px dashed darkgray;\r\n  border-radius: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
